import React, {useEffect, useState} from "react";
import {Button, Col, Form, Row, Select} from "antd";
import {formatTitleCase} from "@lib/format";
import {useGetContactsQuery} from "@mwServices/User";
import AddEditContactDrawer from "@components/add-edit-contact-drawer";
import {FormInstance} from "antd/lib/form/hooks/useForm";
import {useWatch} from "antd/lib/form/Form";

interface ContactSelectProps {
    label: string;
    name: string;
    form: FormInstance;
    addButtonText?: string;
};
const ContactsSelect = ({label, name, form, addButtonText}:ContactSelectProps) => {
    const contactsQuery = useGetContactsQuery();
    const [contacts, setContacts] = useState<any[]>([]);
    const [selectedContact, setSelectedContact] = useState<any>(null);
    const [showAddContact, setShowAddContact]  = useState(false);
    const [showEditContact, setShowEditContact]  = useState(false);
    const [contactOptions, setContactOptions] = useState<{value: string, label: string}[]>([]);

    const formValue = useWatch(name, form);

    useEffect(() => {
        setSelectedContact(null);
        if (contactsQuery.data) {
            if(formValue){
                const contact = contactsQuery.data.find(item => item.id === formValue);
                if(contact) setSelectedContact(contact);
            }
        }
    }, [formValue]);

    useEffect(() => {
        if (contactsQuery.data) {
            setContacts(contactsQuery.data);

            setContactOptions([
                {value: "", label: "Not known"},
                ...contactsQuery.data.map((contact) => {
                    let contactLabel = "";
                    if(contact.contact_name && contact.store_name){
                        contactLabel = `${contact.contact_name} (${contact.store_name})`;
                    } else if(contact.contact_name){
                        contactLabel = contact.contact_name;
                    } else if(contact.store_name){
                        contactLabel = contact.store_name;
                    }else{
                        contactLabel = "No name entered.";
                    }
                    return {
                        value: contact.id,
                        label: formatTitleCase(contactLabel)
                    }
                })
            ]);

            if(formValue){
                const contact = contactsQuery.data.find(item => item.id === formValue);
                setSelectedContact(contact);
            }
        }
    }, [contactsQuery.data]);

    return (
        <>
            <Form.Item label={label} name={name}>
                <Select
                    defaultValue={formValue}
                    value={formValue}
                    onSelect={(value) => {
                        const contact = contacts.find(item => item.id === value);
                        form.setFieldValue(name, value);
                        setSelectedContact(contact);
                    }}
                    options={contactOptions}
                />
                <Button className={'float-right'} type="link" onClick={() => {
                    setShowAddContact(true)
                }} >{addButtonText ? addButtonText : '+Add Contact'}</Button>
            </Form.Item>

            {selectedContact && (
                <Row>
                    <Col span={10} className={'align-left-top'}>
                    </Col>
                    <Col span={14}>
                        {selectedContact.contact_name !== null && selectedContact.contact_name}<br/>
                        {selectedContact.store_name !== null && selectedContact.store_name}<br/>
                        {selectedContact.email !== null && (<>{selectedContact.email} <br/></>)}
                        {selectedContact.phone !== null && (<>{selectedContact.phone} <br/></>)}
                        {selectedContact.address1 !== null && (<>{selectedContact.address1} <br/></>)}
                        {selectedContact.address2 !== null && (<>{selectedContact.address2} <br/></>)}
                        {selectedContact.address3 !== null && (<>{selectedContact.address3} <br/></>)}
                        {selectedContact.address4 !== null && (<>{selectedContact.address4} <br/></>)}
                        {selectedContact.city !== null && (<>{selectedContact.city} <br/></>)}
                        {selectedContact.state !== null && (<>{selectedContact.state} <br/></>)}
                        {selectedContact.zip !== null && (<>{selectedContact.zip} <br/></>)}
                        <Button className={'float-right'} type="link" onClick={() => setShowEditContact(true)} >Edit Contact</Button>
                    </Col>
                </Row>
            )}

            <AddEditContactDrawer
                visible={showAddContact || showEditContact}
                contact={showEditContact && selectedContact}
                onClose={() => {
                    setShowAddContact(false);
                    setShowEditContact(false);
                }}
            />
        </>
    );
};

export default ContactsSelect;